import React, { useEffect, useState } from "react";
import cn from "classnames";
import Footer from "components/Footer/Footer";
import { Link } from "react-router-dom";
import styles from "./signin.module.scss";
import dash_styles from "../mychargers.module.scss";

import { Auth } from "aws-amplify";
import MyChargers from "../myChargers";

async function logIn() {
  try {
    const user = await Auth.signIn(
      "fleetboxstaging@nuvve.com",
      "@!V^f$hR08!wca@!"
    );
    // const user = await Auth.signIn(username, password);
  } catch (error) {
    console.log("error signing in", error);
  }
}

export default function SignIn(props) {
  const [userData, setUserData] = useState({ userName: "", password: "" });
  const [errorMessage, setErrorMessage] = useState({ value: "" });
  useEffect(() => {
    localStorage.removeItem("userName");
    localStorage.removeItem("userCred");
  }, []);
  // Check region to show image
  let region = process.env.REACT_APP_AWS_COGNITO_REGION.slice(0, 2);
  const imgSrc =
    region === "us"
      ? require("assets/loginImg.jpg")
      : require("assets/eu-loginImg.jpg");

  async function logIns(userName, password) {
    try {
      // const user = await Auth.signIn("fleetboxstaging@nuvve.com", "@!V^f$hR08!wca@!");
      if (userName === "" || password === "") {
        setErrorMessage((prevState) => ({
          value: "Empty username/password field",
        }));
      } else {
        const user = await Auth?.signIn(userName, password);
        if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
          localStorage.setItem("userName", userName);
          localStorage.setItem("userCred", password);
          window.location.pathname = "/forceResetPassword";
        } else {
          const { accessToken } = user?.signInUserSession;
          //Signin Success
          localStorage.setItem("userName", userName);
          localStorage.setItem("isLogin", userData);
          localStorage.setItem("accessToken", accessToken.jwtToken);
          window.location.pathname = "/myFleet";
        }
      }
      <myChargers local={localStorage} />;
    } catch (error) {
      console.log("error signing in", error);
      //If credentials entered is invalid
      setErrorMessage((prevState) => ({
        value: "Incorrect login credentials",
      }));
    }
  }

  const handleInputChange = (e) => {
    setUserData((prevState) => {
      return {
        ...prevState,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    logIns(userData.userName, userData.password);
    //if username or password field is empty, return error message
  };

  const handleSubmits = (e) => {
    e.preventDefault();
    logIn();
    //if username or password field is empty, return error message
    if (userData.userName === "" || userData.password === "") {
      setErrorMessage((prevState) => ({
        value: "Empty username/password field",
      }));
    } else if (
      userData.userName.toLowerCase() === "admin" &&
      userData.password === "test@1234"
    ) {
      //Signin Success
      localStorage.setItem("isLogin", true);
      window.location.pathname = "/myChargers";
    } else {
      //If credentials entered is invalid
      setErrorMessage((prevState) => ({ value: "Invalid username/password" }));
      return;
    }
  };

  return (
    <div className={`ldpg ${cn(dash_styles.main, dash_styles.main_layout)}`}>
      <div className={cn(dash_styles.main_flex, dash_styles.main_flex_layout)}>
        <div className={cn(styles.flexcontainer)}>
          <div className={cn(styles.leftSide)}>
            <img
              src={imgSrc.default}
              alt="Rectangle 1"
              className={cn(styles.loginImage)}
            />
          </div>
          <div className={cn(styles.rightSide)}>
            {/* <div style={{"margin": "0 auto", "width": "750px"}}> */}
            <img
              src={require("assets/logo.png").default}
              alt="Rectangle 1"
              className={cn(
                styles.signin_logo_boxl,
                styles.signin_logo_boxl_layout
              )}
            />

            <form onSubmit={handleSubmit}>
              <div
                className={cn(styles.panel_group, styles.panel_group_layout)}
              >
                {errorMessage.value !== "" && (
                  <p className={cn(styles.error)}> {errorMessage.value} </p>
                )}

                <div className={cn(styles.username, styles.username_layout)}>
                  {/* <h1 className={cn(styles.username_title, styles.username_title_layout)}> */}
                  <h1>{"Username"}</h1>
                  {/* </h1> */}
                  <input
                    type="text"
                    name="userName"
                    onChange={(e) => handleInputChange(e)}
                    className={cn(
                      styles.username_box,
                      styles.username_box_layout
                    )}
                  />
                </div>

                <div
                  className={cn(
                    styles.password_block,
                    styles.password_block_layout
                  )}
                >
                  {/* <h1 className={cn(styles.password_title, styles.password_title_layout)}> */}
                  <h1>{"Password"}</h1>
                  {/* </h1> */}
                  <input
                    type="password"
                    name="password"
                    onChange={(e) => handleInputChange(e)}
                    id="password"
                    minLength="8"
                    className={cn(
                      styles.password_box,
                      styles.password_box_layout
                    )}
                  />
                </div>

                <h3
                  className={cn(
                    styles.forgot_reset_text,
                    styles.forgot_reset_text_layout
                  )}
                >
                  <Link to="/forgotPassword">Forgot Password?</Link>
                </h3>

                {/* <Link to="/myChargers" className={cn(styles.text)}> */}
                {/* <div className={cn(styles.panel_group_block, styles.panel_group_block_layout)}> */}
                {/* <h1 className={cn()}>
                {'Sign In'}
            </h1> */}
                <div
                  style={{
                    width: "100%",
                    display: "initial",
                    textAlign: "center",
                  }}
                >
                  <button
                    type="submit"
                    className={cn(
                      styles.panel_group_big_title,
                      styles.panel_group_big_title_layout,
                      styles.panel_group_block,
                      styles.panel_group_block_layout
                    )}
                  >
                    {/* button disabled feature removed */}
                    {/* disabled={!userData.userName || !userData.password}  */}
                    {"Sign In"}
                  </button>
                </div>
                {/* </div> */}
                {/* </Link> */}

                {/* <h3
                  className={cn(styles.register_text_box, styles.register_text_box_layout)}>
                  <div className={cn(styles.register_text)}>
                    <span className={cn(styles.register_text_span0)}>
                      {'Don’t have an account yet? '}
                    </span>
                    <span className={cn(styles.register_text_span1)}>
                      <Link to="#">
                        Register
                      </Link>
                    </span>
                    <span className={cn(styles.register_text_span2)}>{' here.'}</span>
                  </div>
                </h3> */}
              </div>
            </form>
            {/* </div> */}
          </div>
        </div>

        <Footer></Footer>
        {/* <footer className={cn(styles.footer_block, styles.footer_block_layout)}> */}

        {/* <div
          style={{
            '--src': `url(${
              require('assets/logo.png').default
            })`
          }}
          className={cn(styles.footer_line, styles.footer_line_layout)}
        />

        <div className={cn(styles.footer_flex, styles.footer_flex_layout)}>
          <div className={cn(styles.footer_flex_item)}>
            <div
              className={cn(
                styles.footer_text_body,
                styles.footer_text_body_layout
              )}>
              {'Privacy'}
            </div>
          </div>
          <div className={cn(styles.footer_flex_spacer)} />
          <div className={cn(styles.footer_flex_item)}>
            <div
              className={cn(
                styles.footer_text_body1,
                styles.footer_text_body1_layout
              )}>
              {'Terms of use'}
            </div>
          </div>
          <div className={cn(styles.footer_flex_spacer1)} />
          <div className={cn(styles.footer_flex_item)}>
            <div
              className={cn(
                styles.footer_text_body2,
                styles.footer_text_body2_layout
              )}>
              {'Support@nuvve.com'}
            </div>
          </div>
          <div className={cn(styles.footer_flex_spacer2)} />
          <div className={cn(styles.footer_flex_item)}>
            <div
              className={cn(
                styles.footer_text_body3,
                styles.footer_text_body3_layout
              )}>
              {'© 2021 NUVVE Corporation'}
            </div>
          </div>
        </div> */}
        {/* </footer> */}
      </div>
    </div>
  );
}

SignIn.inStorybook = true;
